import { EventBroker } from "@frontend/lib/utils/event-broker";

export const BYNDER_METADATA_EVENTS = {
    INIT: 'INIT',
    HANDLE_META: 'HANDLE_META',
    HANDLE_ADDITIONAL_PROPERTIES: 'HANDLE_ADDITIONAL_PROPERTIES'
};

export const bynderMetadataEventBroker = new EventBroker();
